// extracted by mini-css-extract-plugin
module.exports = {"card":"_27IhDd5Fo6HRy9wMNS3PmC"};